<template>
  <modal
    :show="show"
    save-text="onboarding.next"
    :close-text="modalCloseText"
    :hide-top-close-button="true"
    @close="$emit('close')"
    @save="$emit('save')"
  >
    <div class="text-center pa-6">
      <v-img
        v-if="isBusinessBillingType"
        :src="require('@/assets/icons/bookaweb-logo.svg')"
        max-height="100"
        contain
        class="mb-6 mt-6"
      ></v-img>
      <h2 class="text-h5 mb-4">{{ modalTitle }}</h2>
      <div class="text-body-1 grey--text text--darken-2" v-html="modalDescription"></div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    isBusinessBillingType() {
      return this.type === 'business_billing';
    },
    modalTitle() {
      if (this.isBusinessBillingType) {
        return this.$t('onboarding.business_billing.modal.title');
      }
      return this.$t('onboarding.user_info.modal.title');
    },
    modalDescription() {
      if (this.isBusinessBillingType) {
        return this.$t('onboarding.business_billing.modal.description');
      }
      return this.$t('onboarding.user_info.modal.description');
    },
    modalCloseText() {
      if (this.isBusinessBillingType) {
        return 'onboarding.business_billing.modal.cancel';
      }
      return 'onboarding.user_info.modal.cancel';
    },
  },
};
</script>
